module.exports = __webpack_public_path__ + "static/media/iPad-black-circle.ec14a65d.svg";